import { createPortal } from 'react-dom';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isDeleting: boolean;
};

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, isDeleting }: Props) => {
  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-30">
      <div className="relative flex h-[247px] w-[440px] flex-col items-center gap-8 rounded bg-white p-10 shadow-[0_0_8px_rgba(0,0,0,0.25)]">
        <button
          className="absolute right-2 top-2 flex h-5 w-5 items-center justify-center rounded-full bg-gray-100"
          onClick={onClose}
        >
          <span className="text-xs">×</span>
        </button>
        
        <div className="flex w-[360px] flex-col items-start gap-4">
          <div className="flex flex-col gap-2">
            <h2 className="text-lg font-semibold text-gray-900">完全に削除しますか？</h2>
            <div className="h-px w-[360px] border-t border-gray-400"></div>
          </div>
          <p className="text-sm text-gray-900">
            記事が完全に削除されますがよろしいですか？
          </p>
        </div>
        
        <div className="flex w-[360px] justify-between gap-8">
          <button
            className="flex h-[47px] w-[172px] items-center justify-center rounded-full bg-warning-500 px-6 py-5 text-base font-medium text-white transition-opacity hover:opacity-60"
            onClick={onConfirm}
            disabled={isDeleting}
          >
完全に削除
          </button>
          <button
            className="flex h-[47px] w-[172px] items-center justify-center rounded-full border border-primary-500 bg-white px-6 py-[10px] text-base font-medium text-primary-500 transition-opacity hover:opacity-60"
            onClick={onClose}
            disabled={isDeleting}
          >
            キャンセル
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteConfirmModal;